import { render, staticRenderFns } from "./PaginaCioccolato.vue?vue&type=template&id=6e0596fe&scoped=true"
import script from "./PaginaCioccolato.vue?vue&type=script&lang=js"
export * from "./PaginaCioccolato.vue?vue&type=script&lang=js"
import style0 from "./PaginaCioccolato.vue?vue&type=style&index=0&id=6e0596fe&prod&lang=scss&scoped=true"
import style1 from "./PaginaCioccolato.vue?vue&type=style&index=1&id=6e0596fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0596fe",
  null
  
)

export default component.exports